import useAvailableFwu from './fwu/useAvailableFwu';

const useHolderControlFwVersion = () => {
    const {holderFwu} = useAvailableFwu();

    const availableFirmwares = holderFwu?.availableFirmwares;
    const holderVersions = availableFirmwares?.map((f) => f.version);

    return holderVersions;
};

export default useHolderControlFwVersion;
